import { connect } from 'react-redux';
import Storage from 'utils/storageManager';
import { resolveBranchURL } from 'actions/locationSearch';
import { getSupportContactInfo } from 'actions/content';
import {
  retrieveAndCheckEligibility,
  rentalRetrieveTicketNumber,
  rentalRetrieveAndConfirm,
} from 'actions/modifyRental';
import { breakpointSelector } from 'selectors/breakpoint';
import MODAL from 'constants/modals';
import RESERVATIONS from 'constants/reservations';
import { SESSION_STORAGE } from 'constants/session';
import { openModal } from 'actions/modal/openModal';
import TripCard from './TripCard';

const mapStateToProps = (state, ownProps) => ({
  breakpoint: breakpointSelector(state),
  afterHoursPolicies: ownProps.return_location?.policies?.find(
    (policy) => policy.code === RESERVATIONS.POLICY_CODES.AFHR
  )?.policy_text,

  currentRentalDetails: Storage.SessionStorage.get(SESSION_STORAGE.RENTAL_TICKET_DETAILS, true) || {},
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  redirectToLocationDetailsPage: () => dispatch(resolveBranchURL(ownProps.locationDetailsID)),
  retrieveAndCheckEligibility: (ticketNumber) => dispatch(retrieveAndCheckEligibility(ticketNumber)),
  rentalRetrieveTicketNumber: (ticketNumber, redirect) => dispatch(rentalRetrieveTicketNumber(ticketNumber, redirect)),
  rentalRetrieveAndConfirmAction: () => dispatch(rentalRetrieveAndConfirm()),
  openExtendRentalModal: (country_code) => {
    dispatch(getSupportContactInfo(country_code));
    return dispatch(openModal(MODAL.EXTEND_RENTAL_INFORMATION_MODAL, { props: { country_code } }));
  },
  openAfterHoursModal: (return_directions, afterHoursPolicies) =>
    dispatch(
      openModal(MODAL.AFTER_HOURS_RETURN_INSTRUCTIONS_MODAL, { props: { return_directions, afterHoursPolicies } })
    ),
  openReturnDirectionsModal: (return_directions) =>
    dispatch(openModal(MODAL.RETURN_DIRECTIONS_MODAL, { props: { return_directions } })),

  openLearnMoreAboutRoadsideAssistance: () => dispatch(openModal(MODAL.LEARN_MORE_ABOUT_ROADSIDE_ASSISTANCE_MODAL)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TripCard);
